export default {
    assignment: 'งานที่มอบหมาย',
    inProgress: 'รอการตรวจ',
    complete: 'ตรวจแล้ว',
    reject: 'รอการแก้ไข',
    dueDate: 'กำหนดส่งวันสุดท้าย',
    description: 'คำอธิบาย',
    turnIn: 'ส่งงาน',
    score: 'คะแนนที่ได้',
    turnInForm: 'แบบฟอร์มส่งงาน',
    turnInDate: 'วันที่ส่ง',
    status: 'สถานะ',
    approveDate: 'วันที่ตรวจ',
    cancel: 'ยกเลิกการส่งงาน',
    pending: 'งานที่รอการส่ง',
    approving: 'งานที่ส่งแล้ว',
    comment: 'บันทึกจากผู้ตรวจ',
    courseName: 'รายวิชา',
    activityName: 'ชื่อกิจกรรม',
    noAssignment: 'ไม่มีงานที่มอบหมาย',
    checkDate: 'วันที่ตรวจ',
    approved: 'บันทึกผล',
    approvingForm: 'ผลการตรวจ',
    checkComplete: 'ผ่าน',
    checkRejected: 'ส่งกลับให้แก้ไข',
    checkFailed: 'ไม่ผ่าน',
    teacherComment: 'หมายเหตุจากผู้ตรวจ',
    turnInNo: 'ส่งงานครั้งที่ ',
    canNotUpload: 'ไม่สามารถอัปโหลดไฟล์ ',
    turnInSuccess: 'ทำการส่งงานเรียบร้อยแล้ว',
    cancelConfirm: 'คุณต้องการยกเลิกการส่งงานล่าสุดใช่หรือไม่? (งานที่ส่งล่าสุดจะถูกลบทิ้ง!)',
    cancelSuccess: 'ทำการยกเลิกการส่งงานล่าสุดเรียบร้อยแล้ว',
    openAllTurnIn: 'ตรวจงาน',
    studentInfo: 'ข้อมูลผู้เรียน',
    studentCode: 'รหัสผู้เรียน',
    firstName: 'ชื่อ',
    lastName: 'นามสกุล',
    noStatus: 'โปรดเลือกผลการตรวจจากตัวเลือกก่อน'
}